var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebinars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0073EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5754 13.5C10.4709 13.5 9.57544 14.3954 9.57544 15.5V32.0892H7C7 32.7183 7.46723 33.3216 8.29892 33.7665C9.1306 34.2113 10.2586 34.4613 11.4348 34.4613H36.5652C37.7414 34.4613 38.8694 34.2113 39.7011 33.7665C40.5328 33.3216 41 32.7183 41 32.0892H38.9828V15.5C38.9828 14.3954 38.0873 13.5 36.9828 13.5H11.5754Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.3 17.1613C11.3 16.0567 12.1955 15.1613 13.3 15.1613H35.3C36.4046 15.1613 37.3 16.0567 37.3 17.1613V32H11.3V17.1613Z",
    fill: "#0073EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.33 26.9094C26.4176 26.9094 28.11 25.2171 28.11 23.1295C28.11 21.0418 26.4176 19.3495 24.33 19.3495C22.2424 19.3495 20.55 21.0418 20.55 23.1295C20.55 25.2171 22.2424 26.9094 24.33 26.9094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.246 28C21.1528 28 18.4435 29.6433 16.9434 32.1045H31.5486C30.0485 29.6433 27.3392 28 24.246 28Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/webinars.6b7819da0ef0ab2efc7de371edc5b5b0.svg";
export { ForwardRef as ReactComponent };